export default theme => ({
  root: {
    marginTop: 5
  },
  adviceRoot: {
    marginTop: 20
  },
  entity: {
    paddingRight: 30
  },
  entityTitle: {
    textTransform: 'capitalize',
    color: theme.colors.semantic.info500
  },
  adviceTitle: {
    color: theme.colors.semantic.info500
  },
  field: {
    color: theme.colors.semantic.info500
  },
  divider: {
    width: '100%',
    height: '1px',
    margin: '10px 0',
    backgroundColor: theme.colors.semantic.info150
  }
});